angular.module('app.directives.kermiTimeInput', []).directive('kermiDate',
    ['dateTimePickerModal',
        function (dateTimePickerModal) {
            var obj = {
                scope: {
                    // Object to Save
                    model: '=model',
                    start: "=start",
                    end: "=end",
                    utc : "=utc"
                },
                restrict: 'AE',
                templateUrl: 'views/form/kermi-date.html',

                // -------------------------------------------//
                //              Link function
                // -------------------------------------------//
                link: function (scope, element, attrs, controller) {
                    scope.$watch('model', function (value) {

                        //if (value != scope.model || scope.model == undefined) {

                        scope.init();
                        // scope.updateModel();
                        //}
                    });

                    scope.selectDate = function () {
                        if(scope.utc)
                        {
                            if (scope.start != undefined && new moment.utc(scope.start).isAfter(scope.model)) {
                                scope.model = new moment.utc(scope.start);
                            }
                        }else{
                            if (scope.start != undefined && moment(scope.start).isAfter(scope.model)) {
                                scope.model = moment(scope.start);
                            }
                        }

                        var options = {
                            filter: function (day) {

                                if (day.isBefore(new moment().startOf('day'))) {
                                    return false;
                                }
                                if (scope.end != undefined && day.isAfter(scope.end)) {
                                    return false;
                                }

                                if (scope.start != undefined && day.isBefore( moment(scope.start).startOf('day') )) {
                                    return false;
                                }
                                return true;
                            },
                            hideDate: false,
                            hideTime: false,
                            asUTC: false

                        };
                        var d = moment(scope.model);

                        dateTimePickerModal(d, options).then(function (modal) {
                            modal.close.then(function (data) {
                                if(data)
                                {
                                    scope.model = moment(data);
                                    scope.DisplayValue =  moment(data);
                                }

                            });
                        });

                    };

                    scope.init = function () {
                        if (scope.model) {
                            scope.DisplayValue = moment(scope.model);
                        }
                    };
                    scope.init();

                }
            };
            return obj;


        }])






































    .directive('kermiTimeDurationInput',
        [
            function () {
                var obj = {
                    scope: {
                        model: '=model',
                        timeFormat: '=timeFormat',
                        max : '=max'
                    },

                    templateUrl: 'views/form/kermiTimeDurationInput.html',
                    link: function (scope) {
                        var secondsToMs = 1000;
                        scope.$watch('model', function (value) {
                            if (value != scope.model || !scope.time) {
                                scope.time = scope.durationToTime(value);
                            }

                        });

                        scope.changeValue = function () {
                            var duration = -1;

                            if ( scope.time == undefined) {
                                scope.time = {};
                            }
                            if (!typeof  scope.time.hours == 'int') {
                                scope.time.hours = '0';
                            }
                            if (!typeof  scope.time.minutes == 'int') {
                                scope.time.minutes = '0';
                            }
                            if (!typeof  scope.time.seconds == 'int') {
                                scope.time.seconds = '0';
                            }

                            duration = scope.timeToDuration( scope.time);

                            if(duration >= 0)
                            {
                                if(scope.max != undefined && (scope.max ) <= duration)
                                {

                                    scope.model = scope.max;
                                    duration = scope.max;
                                }else{
                                    scope.model = duration;
                                }

                            }
                            //alert(scope.max+'---'+duration);

                            scope.time =scope.durationToTime(scope.model);
                        };

                        scope.timeToDuration = function (a) {
                            if (!a.hours) {
                                a.hours = 0;
                            }
                            if (!a.minutes) {
                                a.minutes = 0;
                            }
                            if (!a.seconds) {
                                a.seconds = 0;
                            }

                            var val = parseInt( secondsToMs * parseInt( ( (a.hours * (60 * 60)) ) + parseInt((a.minutes * 60 )) + parseInt(a.seconds) ) );
                            switch(scope.timeFormat)
                            {

                                case "s":
                                    val = val / secondsToMs;
                                    break;
                            }
                            return val;
                        };

                        scope.durationToTime = function (a) {

                            if(scope.model == -1){
                                a = 0;
                            }
                            switch(scope.timeFormat)
                            {

                                case "s":
                                    a = a * secondsToMs;
                                    break;
                            }
                            let time;
                            if(a == 0){
                                time = {
                                    "hours":0,
                                    "minutes":0,
                                    "seconds": 0
                                };
                            }else{
                               // alert(a);
                                var b = new moment( a ).utc();
                              //  alert(b.format('hh:mm:ss'));
                                var tstart = new moment('1970-01-01T00:00:00+00:00').utc();
                                var ms = b.diff(tstart);
                                var t = moment.duration(ms);

                                time = {
                                    "hours": Math.abs(Math.floor(t.asHours())),
                                    "minutes": moment.utc(ms ).format("m"),
                                    "seconds": moment.utc(ms).format("s")
                                };
                            }

                            return time;
                            //( (a.hours * (60*60)) + (a.minutes * 60 ) + a.seconds )
                        };
                    }
                };
                return obj;

            }])
;
